import React, { useEffect, useRef } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Navbar from "./Navbar";
import Footer from "./Footer";
import HomeHero from "./HomeHero";
import "../../pages/Home.css";

export default function SiteLayout() {
  const location = useLocation();
  const contentRef = useRef(null);

  // Slightly scroll down so the logo goes out of view but Navbar and Banner stay visible
  useEffect(() => {
    if (location.pathname !== "/") {
      window.scrollTo({ top: 120, behavior: "smooth" });
    }
  }, [location.pathname]);

  return (
    <div className="page-wrapper">
      <div className="home-top-section">
        <Header />
        <Navbar />
        <HomeHero />
      </div>
      <div className="main-content" ref={contentRef}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}
